import Modal from "Components/Modal/Modal";
import ProjectForm from "Components/Project/ProjectForm";
import { createProject } from "Components/Project/ProjectHelper";
import moment from "moment";
import React, { FC } from "react";
import SchedulePhaseForm from "./SchedulePhaseForm";
import { createSchedulePhase } from "./SchedulePhaseHelper";
import { useSchedulePhaseModal } from "./hooks/useSchedulePhaseModal";


const SchedulePhaseModal: FC = () => {
	const isModalOpen = useSchedulePhaseModal((state) => state.isOpen);
	const schedulePhaseModalItem = useSchedulePhaseModal((state) => state.item);
	const schedulePhaseModalProjectSchedulePhase = useSchedulePhaseModal(
		(state) => state?.item
	)?.forSchedulePhase;
	const schedulePhaseModalProject = useSchedulePhaseModal(
		(state) => state?.item
	)?.project;


	if (isModalOpen && schedulePhaseModalItem) {
		const schedulePhase = schedulePhaseModalItem.schedulePhase
			? schedulePhaseModalItem.schedulePhase
			: schedulePhaseModalProjectSchedulePhase && schedulePhaseModalProject
			? createSchedulePhase(
					schedulePhaseModalProjectSchedulePhase.start,
					schedulePhaseModalProjectSchedulePhase.end,
					schedulePhaseModalProject.id
			  )
			: undefined;

		if (schedulePhase && schedulePhaseModalProject) {
			return (
				<Modal modalController={useSchedulePhaseModal.getState()}>
					<SchedulePhaseForm
						schedulePhase={schedulePhase}
						project={schedulePhaseModalProject}
						changeProject={() =>
							useSchedulePhaseModal.getState().openWithItem(
								{
									forSchedulePhase: {
										start: moment.unix(schedulePhase.startDate),
										end: moment.unix(schedulePhase.endDate),
									},
								},
								true
							)
						}
					/>
				</Modal>
			);
		} else if (schedulePhaseModalProjectSchedulePhase) {
			const project = createProject();
			if (!project) return null;

			return (
				<Modal modalController={useSchedulePhaseModal.getState()}>
					<ProjectForm
						close={useSchedulePhaseModal.getState().close}
						project={project}
						forSchedulePhase={schedulePhaseModalProjectSchedulePhase}
						selectExistingProject={(project) => {
							if (schedulePhaseModalProjectSchedulePhase) {
								useSchedulePhaseModal.getState().openWithItem(
									{
										project,
										schedulePhase: createSchedulePhase(
											schedulePhaseModalProjectSchedulePhase.start,
											schedulePhaseModalProjectSchedulePhase.end,
											project.id
										),
									},
									true
								);
							}
						}}
					/>
				</Modal>
			);
		} else {
			return null;
		}
	} else {
		return null;
	}
};

export default SchedulePhaseModal;
